import React, { Component, Fragment } from "react";
import { CRUDFunction } from "../../reduxCURD/container";
import SpinnerLoader from "../Common/SpinnerLoader";
import { sortAlphaNum } from "../../utils/sortingMethods";
import { sessionService } from "../../services/session";

export const FixedAppLookupsContext = React.createContext({
  initialized: false,
  maintenanceTypes: [],
  chargeCodes: [],
  crewSkills: [],
  equipmentTypes: [],
  materialTypes: [],
  hosLocations: [],
  hosDutyTypes: [],
  hosServiceTypes: [],
  hosActivityTypes: [],
  hosLocationsWithAllDetails: [],
  hosActivitiesWithAllDetails: [],
  hosServiceTypesWithAllDetails: [],
  appForms: [],
  refreshLookups: () => { },
  createLookup: () => { },
  updateLookup: () => { },
  deleteLookup: () => { },
  isValidHosLocation: () => false,
  getHosLocationsSelectOptions: () => [],
  getHosLocationOpt2BasedOnCode: () => { },
  getActivityTypeOpt2BasedOnCode: () => ({}),
  getActivityTypeBasedOnServiceType: () => [],
  getActivityTypeSelectOptionsBasedOnServiceType: () => [],
  getAllActivityTypeSelectOptions: () => { },
  getServiceTypeBasedOnDutyType: () => [],
  getServiceTypesWithCodesMultiSelectOptions: () => [],
});

class FixedAppLookups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialized: false,
      spinnerLoading: false,
      updateListName: [],
      maintenanceTypes: [],
      chargeCodes: [],
      crewSkills: [],
      equipmentTypes: [],
      materialTypes: [],
      hosLocations: [],
      hosDutyTypes: [],
      hosServiceTypes: [],
      hosActivityTypes: [],
      hosLocationsWithAllDetails: [],
      hosActivitiesWithAllDetails: [],
      hosServiceTypesWithAllDetails: [],
      appForms: [],
    };
    this.getListType = this.getListType.bind(this);
    this.getListTypeWithAllDetails = this.getListTypeWithAllDetails.bind(this);
    this.refreshLookups = this.refreshLookups.bind(this);
    this.refreshOnlySelectedLookups = this.refreshOnlySelectedLookups.bind(this);
    this.createLookup = this.createLookup.bind(this);
    this.updateLookup = this.updateLookup.bind(this);
    this.deleteLookup = this.deleteLookup.bind(this);
    this.isValidHosLocation = this.isValidHosLocation.bind(this);
    this.getHosLocationsSelectOptions = this.getHosLocationsSelectOptions.bind(this);
    this.getHosLocationOpt2BasedOnCode = this.getHosLocationOpt2BasedOnCode.bind(this);
    this.getActivityTypeOpt2BasedOnCode = this.getActivityTypeOpt2BasedOnCode.bind(this);
    this.getActivityTypeBasedOnServiceType = this.getActivityTypeBasedOnServiceType.bind(this);
    this.getActivityTypeSelectOptionsBasedOnServiceType = this.getActivityTypeSelectOptionsBasedOnServiceType.bind(this);
    this.getAllActivityTypeSelectOptions = this.getAllActivityTypeSelectOptions.bind(this);
    this.getServiceTypeBasedOnDutyType = this.getServiceTypeBasedOnDutyType.bind(this);
    this.getServiceTypesWithCodesMultiSelectOptions = this.getServiceTypesWithCodesMultiSelectOptions.bind(this);
  }

  componentDidMount() {
    this.refreshLookups([
      "maintenanceTypes",
      "chargeCodes",
      "crewSkills",
      "equipmentTypes",
      "materialTypes",
      "crewSkills",
      "equipmentTypes",
      "materialTypes",
      "hosLocations",
      "hosDutyTypes",
      "hosServiceTypes",
      "hosActivityTypes",
      "appForms",
    ]);
  }

  componentDidUpdate(prevProps, prevState) {
    const { actionType, fixedAppLookupss } = this.props;
    const { initialized } = this.state;
    if (initialized && this.props.tempSessionToken !== prevProps.tempSessionToken) {
      this.refreshLookups([
        "maintenanceTypes",
        "chargeCodes",
        "crewSkills",
        "equipmentTypes",
        "materialTypes",
        "crewSkills",
        "equipmentTypes",
        "materialTypes",
        "hosLocations",
        "hosDutyTypes",
        "hosServiceTypes",
        "hosActivityTypes",
        "appForms",
      ]);
    }
    if (prevProps.actionType !== actionType) {
      if (
        actionType === "FIXEDAPPLOOKUPSS_READ_REQUEST" ||
        actionType === "FIXEDAPPLOOKUPS_CREATE_REQUEST" ||
        actionType === "FIXEDAPPLOOKUPS_UPDATE_REQUEST" ||
        actionType === "FIXEDAPPLOOKUPS_DELETE_REQUEST"
      ) {
        this.setState({ spinnerLoading: true });
      } else if (actionType === "FIXEDAPPLOOKUPSS_READ_SUCCESS") {
        if (Array.isArray(fixedAppLookupss)) {
          if (this.state.updateListName.length > 0) {
            // TODO: optimize Following Logic
            this.state.updateListName.includes("maintenanceTypes") &&
              this.setState({
                maintenanceTypes: this.getListType("maintenanceTypes", fixedAppLookupss),
              });
            this.state.updateListName.includes("chargeCodes") &&
              this.setState({
                chargeCodes: this.getListType("chargeCodes", fixedAppLookupss),
              });
            this.state.updateListName.includes("crewSkills") &&
              this.setState({
                crewSkills: this.getListType("crewSkills", fixedAppLookupss),
              });
            this.state.updateListName.includes("equipmentTypes") &&
              this.setState({
                equipmentTypes: this.getListType("equipmentTypes", fixedAppLookupss),
              });
            this.state.updateListName.includes("materialTypes") &&
              this.setState({
                materialTypes: this.getListType("materialTypes", fixedAppLookupss),
              });
            this.state.updateListName.includes("hosLocations") &&
              this.setState({
                hosLocations: this.getListType("hosLocations", fixedAppLookupss),
                hosLocationsWithAllDetails: this.getListTypeWithAllDetails("hosLocations", fixedAppLookupss),
              });
            this.state.updateListName.includes("hosDutyTypes") &&
              this.setState({
                hosDutyTypes: this.getListType("hosDutyTypes", fixedAppLookupss),
              });
            this.state.updateListName.includes("hosServiceTypes") &&
              this.setState({
                hosServiceTypes: this.getListType("hosServiceTypes", fixedAppLookupss),
                hosServiceTypesWithAllDetails: this.getListTypeWithAllDetails("hosServiceTypes", fixedAppLookupss),
              });
            this.state.updateListName.includes("hosActivityTypes") &&
              this.setState({
                hosActivityTypes: this.getListType("hosActivityTypes", fixedAppLookupss),
                hosActivitiesWithAllDetails: this.getListTypeWithAllDetails("hosActivityTypes", fixedAppLookupss),
              });
            this.state.updateListName.includes("appForms") &&
              this.setState({
                appForms: this.getListTypeWithAllDetails("appForms", fixedAppLookupss),
              });
            this.setState({ updateListName: [] });
          } else {
            this.setState({
              maintenanceTypes: this.getListType("maintenanceTypes", fixedAppLookupss),
              chargeCodes: this.getListType("chargeCodes", fixedAppLookupss),
              crewSkills: this.getListType("crewSkills", fixedAppLookupss),
              equipmentTypes: this.getListType("equipmentTypes", fixedAppLookupss),
              materialTypes: this.getListType("materialTypes", fixedAppLookupss),
              hosLocations: this.getListType("hosLocations", fixedAppLookupss),
              hosDutyTypes: this.getListType("hosDutyTypes", fixedAppLookupss),
              hosServiceTypes: this.getListType("hosServiceTypes", fixedAppLookupss),
              hosActivityTypes: this.getListType("hosActivityTypes", fixedAppLookupss),
              hosLocationsWithAllDetails: this.getListTypeWithAllDetails("hosLocations", fixedAppLookupss),
              hosActivitiesWithAllDetails: this.getListTypeWithAllDetails("hosActivityTypes", fixedAppLookupss),
              hosServiceTypesWithAllDetails: this.getListTypeWithAllDetails("hosServiceTypes", fixedAppLookupss),
              appForms: this.getListTypeWithAllDetails("appForms", fixedAppLookupss),
              initialized: true,
            });
          }
        }
        this.setState({ spinnerLoading: false });
      } else if (
        actionType === "FIXEDAPPLOOKUPS_CREATE_SUCCESS" ||
        actionType === "FIXEDAPPLOOKUPS_UPDATE_SUCCESS" ||
        actionType === "FIXEDAPPLOOKUPS_DELETE_SUCCESS"
      ) {
        // updated successfully
        this.setState({ spinnerLoading: false });
        this.state.updateListName.length > 0 && this.refreshLookups(this.state.updateListName);
      } else if (
        actionType === "FIXEDAPPLOOKUPS_READ_FAILURE" ||
        actionType === "FIXEDAPPLOOKUPSS_CREATE_FAILURE" ||
        actionType === "FIXEDAPPLOOKUPSS_UPDATE_FAILURE" ||
        actionType === "FIXEDAPPLOOKUPS_DELETE_FAILURE"
      ) {
        this.setState({ updateListName: [], spinnerLoading: false });
      }
    }
  }

  refreshLookups(listNames = []) {

    let access_token = this.props.tempSessionToken || sessionService.getToken() || localStorage.getItem("access_token");

    if (access_token) {
      this.props.getFixedAppLookupss(listNames);
    } else {
      this.setState({
        initialized: true,
      });
    }
  }
  refreshOnlySelectedLookups(listNames = []) {

    let access_token = this.props.tempSessionToken || sessionService.getToken() || localStorage.getItem("access_token");

    if (access_token) {
      this.setState({ updateListName: listNames });
      this.props.getFixedAppLookupss(listNames);
    } else {
      this.setState({
        initialized: true,
      });
    }
  }

  getActivityTypeOpt2BasedOnCode(code) {
    const { hosActivitiesWithAllDetails } = this.state;
    const activityTypeInList = hosActivitiesWithAllDetails.find((type) => type.code === code);
    if (!activityTypeInList) return {};

    return activityTypeInList.opt2;
  }

  getHosLocationOpt2BasedOnCode(code) {
    const { hosLocationsWithAllDetails } = this.state;
    const hosLocationInList = hosLocationsWithAllDetails.find((type) => type.code === code);
    if (!hosLocationInList) return {};

    return hosLocationInList.opt2;
  }

  getActivityTypeBasedOnServiceType(serviceType) {
    const { hosActivitiesWithAllDetails, hosServiceTypesWithAllDetails } = this.state;
    const serviceTypeInList = hosServiceTypesWithAllDetails.find((type) => type.description === serviceType);
    if (!serviceTypeInList) return [];

    return hosActivitiesWithAllDetails
      .filter((type) => type.opt2 && Array.isArray(type.opt2.serviceCodes) && type.opt2.serviceCodes.includes(serviceTypeInList.code))
      .map((type) => type.description);
  }

  getActivityTypeSelectOptionsBasedOnServiceType(serviceType, all) {
    const { hosActivitiesWithAllDetails, hosServiceTypesWithAllDetails } = this.state;
    const serviceTypeInList = hosServiceTypesWithAllDetails.find((type) => type.description === serviceType);
    if (!serviceTypeInList) return [];

    return [
      { val: "", text: "Select" },
      ...hosActivitiesWithAllDetails
        .filter((type) => type.opt2 && Array.isArray(type.opt2.serviceCodes) && type.opt2.serviceCodes.includes(serviceTypeInList.code))
        .map((type) => {
          const { opt2, code } = type;
          let text = opt2.value;
          if (opt2.code) {
            text = text + ` (${opt2.code})`;
          }
          return { text: text, val: code };
        }),
    ];
  }

  getAllActivityTypeSelectOptions(excludeServiceType = "") {
    // description
    const { hosActivitiesWithAllDetails, hosServiceTypesWithAllDetails } = this.state;
    const excludeServiceTypeCodes = hosServiceTypesWithAllDetails
      .filter((type) => excludeServiceType === type.description)
      .map((type) => type.code);

    return [
      { val: "", text: "Select" },
      ...hosActivitiesWithAllDetails
        .filter(
          (type) => type.opt2 && Array.isArray(type.opt2.serviceCodes) && !type.opt2.serviceCodes.includes(excludeServiceTypeCodes[0]),
        )
        .map((type) => {
          const { opt2, code } = type;
          let text = opt2.value;
          if (opt2.code) {
            text = text + ` (${opt2.code})`;
          }
          return { text: text, val: code };
        }),
    ];
  }

  getServiceTypeBasedOnDutyType(dutyType) {
    const { hosServiceTypes } = this.state;

    const dutyServiceMap = {
      "Normal Service": ["Covered Service", "Non-covered Service", "Commingled Service"],
      "Trouble Call": ["Covered Service", "Non-covered Service", "Commingled Service"],
      "Interrupted Rest": ["Covered Service", "Non-covered Service", "Commingled Service"],
      "Off Duty": ["Off Duty"],
      Limbo: ["Limbo"],
      Other: ["Meal"],
    };
    const allowedServiceDescriptions = dutyServiceMap[dutyType] || dutyServiceMap["Normal Service"];
    return hosServiceTypes.filter((type) => allowedServiceDescriptions.includes(type));
  }

  getServiceTypesWithCodesMultiSelectOptions(filter = false, dutyType) {
    const { hosServiceTypesWithAllDetails } = this.state;
    const offDutyType = "Off Duty";
    let allDetails = [];
    if (filter) {
      if (dutyType === offDutyType) {
        allDetails = hosServiceTypesWithAllDetails.filter((item) => item.description === offDutyType);
      } else {
        allDetails = hosServiceTypesWithAllDetails.filter((item) => item.description !== offDutyType);
      }
    } else {
      allDetails = [...hosServiceTypesWithAllDetails];
    }
    return allDetails.map((item) => ({ val: item.code, text: item.description }));
  }
  // Auto-extract the code if not provided
  createLookup(listItem, lookupWithAllDetails = []) {
    if (!listItem || !listItem.listName) return false;

    if (!listItem.code) {
      if (!Array.isArray(lookupWithAllDetails) || !lookupWithAllDetails.length) return false;
      let latestItemCode = lookupWithAllDetails.map((item) => item.code).sort(sortAlphaNum, true)[0];
      if (!latestItemCode) return 0;

      let [last, ...other] = latestItemCode.split("-").reverse();
      listItem.code = [parseInt(last) + 1, ...other].reverse().join("-");
    }

    this.props.createFixedAppLookups(listItem, "applicationlookups");
    this.setState({ updateListName: [listItem.listName] });
    return true;
  }

  updateLookup(listItem) {
    if (!listItem || !listItem.listName) return false;
    this.props.updateFixedAppLookups(listItem, listItem._id);
    this.setState({ updateListName: [listItem.listName] });
    return true;
  }
  deleteLookup(listItem) {
    if (!listItem || !listItem.listName) return false;
    this.props.deleteFixedAppLookups(listItem);
    this.setState({ updateListName: [listItem.listName] });
    return true;
  }

  getListType(listName, lists) {
    let list = lists.filter((v) => {
      return v.listName === listName;
    });
    list = list.map((v) => {
      return v.description;
    });

    return list;
  }

  getListTypeWithAllDetails(listName, lists) {
    return lists.filter((v) => {
      return v.listName === listName;
    });
  }

  isValidHosLocation(code) {
    const { hosLocationsWithAllDetails } = this.state;
    return hosLocationsWithAllDetails.find((loc) => loc.code === code) ? true : false;
  }

  getHosLocationsSelectOptions() {
    const { hosLocationsWithAllDetails } = this.state;
    return [{ val: "", text: "Select" }, ...hosLocationsWithAllDetails.map((item) => ({ val: item.code, text: item.opt2.description }))];
  }

  render() {
    return (
      <FixedAppLookupsContext.Provider
        value={{
          ...this.state,
          createLookup: this.createLookup,
          updateLookup: this.updateLookup,
          deleteLookup: this.deleteLookup,
          refreshLookups: this.refreshLookups,
          refreshOnlySelectedLookups: this.refreshOnlySelectedLookups,
          isValidHosLocation: this.isValidHosLocation,
          getHosLocationsSelectOptions: this.getHosLocationsSelectOptions,
          getActivityTypeOpt2BasedOnCode: this.getActivityTypeOpt2BasedOnCode,
          getHosLocationOpt2BasedOnCode: this.getHosLocationOpt2BasedOnCode,
          getActivityTypeBasedOnServiceType: this.getActivityTypeBasedOnServiceType,
          getActivityTypeSelectOptionsBasedOnServiceType: this.getActivityTypeSelectOptionsBasedOnServiceType,
          getAllActivityTypeSelectOptions: this.getAllActivityTypeSelectOptions,
          getServiceTypeBasedOnDutyType: this.getServiceTypeBasedOnDutyType,
          getServiceTypesWithCodesMultiSelectOptions: this.getServiceTypesWithCodesMultiSelectOptions,
        }}
      >
        <Fragment>
          <SpinnerLoader spinnerLoading={this.state.spinnerLoading} />
          {this.state.initialized && this.props.children}
        </Fragment>
      </FixedAppLookupsContext.Provider>
    );
  }
}
const FixedAppLookupsContextProvider = CRUDFunction(FixedAppLookups, "fixedAppLookups", null, null, null, "applicationlookups");
export default FixedAppLookupsContextProvider;



// WEBPACK FOOTER //
// ./src/components/FixedAppLookupsProvider/index.jsx